import CannedFishProduct from 'models/CannedFishProduct'

export const fishTypeOptions = [
  {
    value: '',
    label: 'Fish Type',
    isDisabled: true,
  },
  {
    value: 'Chunk, Light Tuna',
    label: 'Chunk, Light Tuna',
    subCategory: '001',
  },
  {
    value: 'Pink Salmon',
    label: 'Pink Salmon',
    subCategory: '002',
  },
  {
    value: 'Sardines',
    label: 'Sardines',
    subCategory: '003',
  },
]

export const packedInOptionsDefault = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
]

export const sizeOptionsDefault = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
]

export const tunaPackedInOptions = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
  { value: 'Water', label: 'Water' },
]

export const tunaSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '5 oz can', label: '5 oz can' },
]

export const salmonPackedInOptions = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
  { value: 'Water', label: 'Water' },
]

export const salmonSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '5 oz can', label: '5 oz can' },
  { value: '6 oz can', label: '6 oz can' },
  { value: '14.75 oz can', label: '14.75 oz can' },
]

export const sardinesPackedInOptions = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
  { value: 'Water', label: 'Water' },
  {
    value: 'Mustard',
    label: 'Mustard',
  },
  { value: 'Tomato Sauce', label: 'Tomato Sauce' },
]

export const sardinesSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '5.5 oz can', label: '5.5 oz can' },
  { value: '15 oz can', label: '15 oz can' },
]

export const packagingInitialState = {
  category: CannedFishProduct.category,
  subCategory: CannedFishProduct.subCategory,
  FishType: {
    value: fishTypeOptions[0].value,
    label: fishTypeOptions[0].label,
  },
  PackedIn: {
    value: packedInOptionsDefault[0].value,
    label: packedInOptionsDefault[0].label,
  },
  Size: {
    value: sizeOptionsDefault[0].value,
    label: sizeOptionsDefault[0].label,
  },
}
